/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import { AttributesFilterVariantFragmentDoc } from '../fragments/attributesFilterVariant.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IInternalFilterOptionsByFilterGroupQueryVariables = Types.Exact<{
  input: Types.IInternalFilterOptionsByFilterGroupInput;
}>;

export type IInternalFilterOptionsByFilterGroupQuery = {
  __typename?: 'Query';
  internalFilterOptionsByFilterGroup: {
    __typename: 'FilterResponse';
    exposedFilterIds: Array<string>;
    allFilters: Array<{
      __typename: 'FilterV2';
      id: string;
      code: string;
      label: string;
      type: Types.IFilterType;
      attributes:
        | {
            __typename?: 'FilterListLevelVariant';
            searchPlaceholder?: string | null;
            appliedFiltersCount: number;
            appliedFilters: Array<{
              __typename?: 'FilterPayloadListValue';
              value: string;
              code: string;
              label?: string | null;
              sublabel?: string | null;
              parentIds?: Array<string> | null;
              hasChildren?: boolean | null;
              lastLevelFilterCount?: number | null;
              siblingCounts?: number | null;
            }>;
          }
        | {
            __typename?: 'FilterListVariant';
            searchPlaceholder?: string | null;
            appliedFiltersCount: number;
            filterGroups: Array<{
              __typename?: 'FilterGroupV2';
              label?: string | null;
              availableFilters: Array<{
                __typename?: 'FilterPayloadValue';
                label?: string | null;
                value: string;
                sublabel?: string | null;
              }>;
            }>;
            appliedFilters: Array<{
              __typename?: 'FilterPayloadValue';
              label?: string | null;
              value: string;
              sublabel?: string | null;
            }>;
          }
        | {
            __typename?: 'FilterRangeVariant';
            range: { __typename?: 'FilterRange'; min: number; max: number };
            activeRange?: { __typename?: 'FilterRange'; min: number; max: number } | null;
          };
    }>;
  };
};

export const InternalFilterOptionsByFilterGroupDocument = gql`
  query internalFilterOptionsByFilterGroup($input: InternalFilterOptionsByFilterGroupInput!) {
    internalFilterOptionsByFilterGroup(input: $input) {
      __typename
      allFilters {
        __typename
        id
        code
        label
        type
        attributes {
          ...AttributesFilterVariant
        }
      }
      exposedFilterIds
    }
  }
  ${AttributesFilterVariantFragmentDoc}
`;

/**
 * __useInternalFilterOptionsByFilterGroupQuery__
 *
 * To run a query within a React component, call `useInternalFilterOptionsByFilterGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalFilterOptionsByFilterGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalFilterOptionsByFilterGroupQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInternalFilterOptionsByFilterGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    IInternalFilterOptionsByFilterGroupQuery,
    IInternalFilterOptionsByFilterGroupQueryVariables
  > &
    ({ variables: IInternalFilterOptionsByFilterGroupQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IInternalFilterOptionsByFilterGroupQuery, IInternalFilterOptionsByFilterGroupQueryVariables>(
    InternalFilterOptionsByFilterGroupDocument,
    options,
  );
}
export function useInternalFilterOptionsByFilterGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IInternalFilterOptionsByFilterGroupQuery,
    IInternalFilterOptionsByFilterGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    IInternalFilterOptionsByFilterGroupQuery,
    IInternalFilterOptionsByFilterGroupQueryVariables
  >(InternalFilterOptionsByFilterGroupDocument, options);
}
// @ts-ignore
export function useInternalFilterOptionsByFilterGroupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IInternalFilterOptionsByFilterGroupQuery,
    IInternalFilterOptionsByFilterGroupQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  IInternalFilterOptionsByFilterGroupQuery,
  IInternalFilterOptionsByFilterGroupQueryVariables
>;
export function useInternalFilterOptionsByFilterGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IInternalFilterOptionsByFilterGroupQuery,
        IInternalFilterOptionsByFilterGroupQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  IInternalFilterOptionsByFilterGroupQuery | undefined,
  IInternalFilterOptionsByFilterGroupQueryVariables
>;
export function useInternalFilterOptionsByFilterGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IInternalFilterOptionsByFilterGroupQuery,
        IInternalFilterOptionsByFilterGroupQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    IInternalFilterOptionsByFilterGroupQuery,
    IInternalFilterOptionsByFilterGroupQueryVariables
  >(InternalFilterOptionsByFilterGroupDocument, options);
}
export type InternalFilterOptionsByFilterGroupQueryHookResult = ReturnType<
  typeof useInternalFilterOptionsByFilterGroupQuery
>;
export type InternalFilterOptionsByFilterGroupLazyQueryHookResult = ReturnType<
  typeof useInternalFilterOptionsByFilterGroupLazyQuery
>;
export type InternalFilterOptionsByFilterGroupSuspenseQueryHookResult = ReturnType<
  typeof useInternalFilterOptionsByFilterGroupSuspenseQuery
>;
export type InternalFilterOptionsByFilterGroupQueryResult = Apollo.QueryResult<
  IInternalFilterOptionsByFilterGroupQuery,
  IInternalFilterOptionsByFilterGroupQueryVariables
>;
